import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'outline' | 'danger';

const VARIANT_CLASSES: Record<Variant, string> = {
  primary: 'bg-[var(--color-t3-blue)] text-white hover:brightness-95',
  secondary: 'bg-[var(--color-t3-purple)] text-white hover:brightness-95',
  outline: 'bg-transparent text-[var(--color-t3-blue)] border border-[var(--color-t3-blue)] hover:bg-[var(--color-t3-blue)]/10',
  danger: 'bg-[var(--color-danger)] text-white hover:brightness-95',
};

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function Button({ variant = 'primary', className, ...rest }: Props): React.ReactElement {
  return (
    <button
      {...rest}
      className={[
        'inline-flex items-center justify-center gap-2 rounded-[var(--radius-button)] px-5 py-2.5 text-sm font-semibold transition active:scale-[0.98] disabled:cursor-not-allowed disabled:bg-[#cccccc] disabled:text-[#888888] disabled:hover:brightness-100',
        VARIANT_CLASSES[variant],
        className ?? '',
      ].join(' ')}
    />
  );
}
